/* The mockup's `.field`, `.label`, `.help` and `.err-text`. */
.field {
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
}

.label {
  font-size: var(--font-size-13);
  font-weight: var(--font-weight-medium);
  color: var(--text);
}

.hint {
  font-size: var(--font-size-12);
  color: var(--text-subtle);
}

.error {
  font-size: var(--font-size-12);
  color: var(--danger-text);
}

.required {
  color: var(--danger-text);
}
